module.exports = __webpack_public_path__ + "static/media/other-income-2.2bcac245.svg";